import * as i4 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import * as i3$1 from 'ngx-bootstrap/popover';
import { PopoverDirective, PopoverModule } from 'ngx-bootstrap/popover';
import * as i2 from 'primeng/dynamicdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { OverflowTooltipModule } from '@niceltd/cxone-components/overflow-tooltip';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, QueryList, Component, ViewEncapsulation, Input, ViewChild, Output, ViewChildren, NgModule } from '@angular/core';
import { SvgIcons, ComponentKeys } from '@niceltd/cxone-components/shared-services';
import * as i1 from '@angular/platform-browser';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
const _c0 = ["cxoneModalWrapper"];
const _c1 = ["pop"];
function ModalComponent_ng_content_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2, ["*ngIf", "customHeader"]);
  }
}
function ModalComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.headerTitle);
  }
}
function ModalComponent_i_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 16, 17);
    i0.ɵɵpipe(2, "translate");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r10 = i0.ɵɵreference(19);
    i0.ɵɵproperty("innerHTML", ctx_r3.iconClose, i0.ɵɵsanitizeHtml)("popover", _r10);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 3, "cxone-components.modal.close"));
  }
}
function ModalComponent_i_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 18);
    i0.ɵɵlistener("keyup.enter", function ModalComponent_i_9_Template_i_keyup_enter_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.dismiss());
    })("click", function ModalComponent_i_9_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.dismiss());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r4.iconClose, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "cxone-components.modal.close"));
  }
}
function ModalComponent_ng_content_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3, ["*ngIf", "customFooter"]);
  }
}
function ModalComponent_button_15_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r16.cancelLabel);
  }
}
function ModalComponent_button_15_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "cxone-components.modal.cancel"));
  }
}
function ModalComponent_button_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 19, 17);
    i0.ɵɵtemplate(2, ModalComponent_button_15_span_2_Template, 2, 1, "span", 4)(3, ModalComponent_button_15_span_3_Template, 3, 3, "span", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r10 = i0.ɵɵreference(19);
    i0.ɵɵproperty("popover", _r10);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.cancelLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r6.cancelLabel);
  }
}
function ModalComponent_button_16_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r18.cancelLabel);
  }
}
function ModalComponent_button_16_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "cxone-components.modal.cancel"));
  }
}
function ModalComponent_button_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function ModalComponent_button_16_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.dismiss());
    });
    i0.ɵɵtemplate(1, ModalComponent_button_16_span_1_Template, 2, 1, "span", 4)(2, ModalComponent_button_16_span_2_Template, 3, 3, "span", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r7.cancelLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r7.cancelLabel);
  }
}
function ModalComponent_button_17_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r22.saveLabel);
  }
}
function ModalComponent_button_17_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "cxone-components.modal.save"));
  }
}
function ModalComponent_button_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function ModalComponent_button_17_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.close());
    });
    i0.ɵɵtemplate(1, ModalComponent_button_17_span_1_Template, 2, 1, "span", 4)(2, ModalComponent_button_17_span_2_Template, 3, 3, "span", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r8.saveDisabled)("hidden", ctx_r8.saveHidden);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r8.saveLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r8.saveLabel);
  }
}
function ModalComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 23)(8, "button", 24);
    i0.ɵɵlistener("click", function ModalComponent_ng_template_18_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r27);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.closePopover());
    });
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "button", 25);
    i0.ɵɵlistener("click", function ModalComponent_ng_template_18_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r27);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.dismiss());
    });
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "cxone-components.modal.message1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, "cxone-components.modal.message2"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 8, "cxone-components.modal.no"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 10, "cxone-components.modal.yes"));
  }
}
const _c2 = [[["cxone-modal-body"]], "*", [["cxone-modal-header"]], [["cxone-modal-footer"]]];
const _c3 = (a0, a1) => ({
  "modal-size-sm": a0,
  "modal-size-md": a1
});
const _c4 = ["cxone-modal-body", "*", "cxone-modal-header", "cxone-modal-footer"];
const _c5 = ["*"];
function MessageModalComponent_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function MessageModalComponent_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDismiss());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.closeButtonText);
  }
}
function MessageModalComponent_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function MessageModalComponent_button_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onClose());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.primaryButtonText);
  }
}
const _c6 = a0 => ({
  "title-only": a0
});
const _c7 = a0 => ({
  "multiline": a0
});
class ModalComponent {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
    /* Adds a close icon to the header to hide the modal */
    this.allowClose = true;
    /* adjusts styling according to size (small/medium-large) */
    this.modalSize = 's';
    /* when true, modal should set focus on the first interactive element when opened */
    this.focusOnShow = false;
    /*Event handler for when the modal is closed with a positive intent */
    this.closed = new EventEmitter();
    /*Event handler for when the modal is cancelled or dismissed */
    this.dismissed = new EventEmitter();
    /*Get svg icons for notification modals*/
    this.svgIcons = new SvgIcons(this.sanitizer);
    this.popovers = new QueryList();
  }
  ngOnInit() {
    this.iconClose = this.svgIcons.getSvgIcons('icon-close');
  }
  ngAfterViewInit() {
    if (this.focusOnShow) {
      // this will hold the first interactive element, once it is found
      let iElementFirst;
      // search these three sections of the modal, in this order, to find the first interactive element
      ['.modal-body-wrapper', '.modal-footer-wrapper', '.modal-header-wrapper'].forEach(sectionSelector => {
        // only check a section if the first interactive element hasn't already been found in a higher priority section
        if (!iElementFirst) {
          // get the container element of the current section
          const sectionEl = this.cxoneModalWrapper.nativeElement.querySelector(sectionSelector);
          // if this section exists, find all the interactive elements in it
          if (sectionEl) {
            const iElements = [...sectionEl.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"]), i[role=button]')].filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
            // if there is at least one interactive element in the section, then select it as iElementFirst
            if (iElements && iElements.length > 0 && iElements[0]) {
              iElementFirst = iElements[0];
            }
          }
        }
      });
      // if a first interactive element was found, focus on it
      if (iElementFirst) {
        setTimeout(function () {
          iElementFirst.focus();
        }, 0);
      }
    }
  }
  closePopover() {
    this.popovers.forEach(pop => {
      pop.hide();
    });
  }
  close() {
    this.closed.emit();
  }
  dismiss() {
    this.dismissed.emit();
  }
  /** @nocollapse */
  static {
    this.ɵfac = function ModalComponent_Factory(t) {
      return new (t || ModalComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalComponent,
      selectors: [["cxone-modal"]],
      viewQuery: function ModalComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5, PopoverDirective);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cxoneModalWrapper = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popovers = _t);
        }
      },
      inputs: {
        allowClose: "allowClose",
        cancelLabel: "cancelLabel",
        customHeader: "customHeader",
        customFooter: "customFooter",
        headerSubtitle: "headerSubtitle",
        headerTitle: "headerTitle",
        saveDisabled: "saveDisabled",
        saveHidden: "saveHidden",
        saveLabel: "saveLabel",
        modalSize: "modalSize",
        focusOnShow: "focusOnShow"
      },
      outputs: {
        closed: "closed",
        dismissed: "dismissed"
      },
      ngContentSelectors: _c4,
      decls: 20,
      vars: 13,
      consts: [[1, "cxone-modal-wrapper", 3, "ngClass"], ["cxoneModalWrapper", ""], [1, "modal-header-wrapper"], [1, "content-wrapper"], [4, "ngIf"], ["class", "headerTitle", 4, "ngIf"], ["ng-if", "headerSubtitle && !customHeader", 1, "headerSubtitle"], ["class", "close-button", "role", "button", "placement", "bottom", "containerClass", "closing-popup", "outsideClick", "true", 3, "innerHTML", "popover", 4, "ngIf"], ["class", "close-button", "role", "button", "tabindex", "1", 3, "innerHTML", "keyup.enter", "click", 4, "ngIf"], [1, "modal-body-wrapper"], [1, "modal-footer-wrapper"], ["class", "cxone-btn btn-medium btn-secondary btn-bg-is-white cancel-btn", "outsideClick", "true", "placement", "top", "tabindex", "1", "containerClass", "closing-popup", 3, "popover", 4, "ngIf"], ["class", "cxone-btn btn-medium btn-secondary btn-bg-is-white cancel-btn", "tabindex", "1", 3, "click", 4, "ngIf"], ["class", "cxone-btn btn-medium btn-primary save-btn", "tabindex", "1", 3, "disabled", "hidden", "click", 4, "ngIf"], ["closingPopup", ""], [1, "headerTitle"], ["role", "button", "placement", "bottom", "containerClass", "closing-popup", "outsideClick", "true", 1, "close-button", 3, "innerHTML", "popover"], ["pop", ""], ["role", "button", "tabindex", "1", 1, "close-button", 3, "innerHTML", "keyup.enter", "click"], ["outsideClick", "true", "placement", "top", "tabindex", "1", "containerClass", "closing-popup", 1, "cxone-btn", "btn-medium", "btn-secondary", "btn-bg-is-white", "cancel-btn", 3, "popover"], ["tabindex", "1", 1, "cxone-btn", "btn-medium", "btn-secondary", "btn-bg-is-white", "cancel-btn", 3, "click"], ["tabindex", "1", 1, "cxone-btn", "btn-medium", "btn-primary", "save-btn", 3, "disabled", "hidden", "click"], [1, "closing-popup"], [1, "button-wrapper"], ["id", "close-popover", "tabindex", "1", 1, "cxone-btn", "btn-secondary", "btn-medium", "btn-bg-is-white", 3, "click"], ["id", "exit-yes-btn", "tabindex", "1", 1, "cxone-btn", "btn-medium", "btn-primary", 3, "click"]],
      template: function ModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2)(3, "div", 3);
          i0.ɵɵtemplate(4, ModalComponent_ng_content_4_Template, 1, 0, "ng-content", 4)(5, ModalComponent_div_5_Template, 2, 1, "div", 5);
          i0.ɵɵelementStart(6, "div", 6);
          i0.ɵɵtext(7);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(8, ModalComponent_i_8_Template, 3, 5, "i", 7)(9, ModalComponent_i_9_Template, 2, 4, "i", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "div", 9);
          i0.ɵɵprojection(11);
          i0.ɵɵprojection(12, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "div", 10);
          i0.ɵɵtemplate(14, ModalComponent_ng_content_14_Template, 1, 0, "ng-content", 4)(15, ModalComponent_button_15_Template, 4, 3, "button", 11)(16, ModalComponent_button_16_Template, 3, 2, "button", 12)(17, ModalComponent_button_17_Template, 3, 4, "button", 13);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(18, ModalComponent_ng_template_18_Template, 16, 12, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c3, ctx.modalSize === "s", ctx.modalSize === "m"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.customHeader);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.customHeader);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.headerSubtitle);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.allowClose);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.allowClose);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.customFooter);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.allowClose && !ctx.customFooter);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.allowClose && !ctx.customFooter);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.customFooter);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i3$1.PopoverDirective, i4.TranslationPipe],
      styles: [".cxone-modal-wrapper{position:absolute;font-family:OpenSans;display:flex;box-shadow:0 5px 20px #0a141a;flex-direction:column;height:100%;width:100%;margin:auto 0}.cxone-modal-wrapper .closing-popup{display:table!important;background:#373b3f;border-radius:0;max-width:250px}.cxone-modal-wrapper .closing-popup.popover-bottom .arrow:after{border-bottom-color:#373b3f}.cxone-modal-wrapper .closing-popup.popover-top .arrow:after{border-top-color:#373b3f}.cxone-modal-wrapper .closing-popup .popover-content{color:#fff}.cxone-modal-wrapper .closing-popup .popover-content .closing-popup p{margin-bottom:10px}.cxone-modal-wrapper .closing-popup .popover-content .closing-popup .button-wrapper{margin-top:14px;display:flex;align-items:center;justify-content:flex-end}.cxone-modal-wrapper .closing-popup .popover-content .closing-popup .button-wrapper button{margin-left:8px}.cxone-modal-wrapper .modal-header-wrapper{display:flex;height:60px;align-items:center;border-top-left-radius:5px;border-top-right-radius:5px;background-color:#fff;padding:0 30px;flex-grow:0;flex-shrink:0}.cxone-modal-wrapper .modal-header-wrapper .content-wrapper{flex:1;padding-top:5px}.cxone-modal-wrapper .modal-header-wrapper .content-wrapper .headerTitle,.cxone-modal-wrapper .modal-header-wrapper .content-wrapper .headerSubtitle{font-size:16px;color:#2e2e2e}.cxone-modal-wrapper .modal-header-wrapper .close-button{cursor:pointer;width:18px;height:18px;fill:#526b7a;opacity:.8}.cxone-modal-wrapper .modal-header-wrapper .close-button:hover{fill:#2d78c2}.cxone-modal-wrapper .modal-header-wrapper .close-button:active{fill:#237bc2}.cxone-modal-wrapper .modal-header-wrapper .close-button svg{pointer-events:none;position:relative;left:-2px}.cxone-modal-wrapper .modal-body-wrapper{flex:1;background-color:#eaf1f7;overflow:auto;position:relative}.cxone-modal-wrapper .modal-footer-wrapper{display:flex;align-items:center;justify-content:flex-end;border-bottom-right-radius:5px;border-bottom-left-radius:5px;background-color:#fff;height:48px;width:100%}.cxone-modal-wrapper .modal-footer-wrapper cxone-modal-footer{flex:1}.cxone-modal-wrapper .modal-footer-wrapper .cancel-btn,.cxone-modal-wrapper .modal-footer-wrapper .save-btn{margin-right:10px}.cxone-modal-wrapper .modal-footer-wrapper button[hidden]{display:none}.cxone-modal-wrapper.modal-size-sm .modal-header-wrapper{padding:0 20px}.cxone-modal-wrapper.modal-size-sm .modal-body-wrapper{padding:20px;position:relative}.cxone-modal-wrapper.modal-size-md .modal-header-wrapper{padding:0 30px}.cxone-modal-wrapper.modal-size-md .modal-body-wrapper{padding:25px 30px;position:relative}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-modal',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"cxone-modal-wrapper\" [ngClass]=\"{'modal-size-sm': modalSize === 's', 'modal-size-md': modalSize === 'm'}\" #cxoneModalWrapper>\n  <div class=\"modal-header-wrapper\">\n    <div class=\"content-wrapper\">\n      <ng-content select=\"cxone-modal-header\" *ngIf=\"customHeader\"></ng-content>\n      <div class=\"headerTitle\" *ngIf=\"!customHeader\">{{headerTitle}}</div>\n      <div class=\"headerSubtitle\" ng-if=\"headerSubtitle && !customHeader\">{{headerSubtitle}}</div>\n    </div>\n    <i class=\"close-button\" role=\"button\" [attr.aria-label]=\"'cxone-components.modal.close' | translate\" *ngIf=\"!allowClose\" [innerHTML]=\"iconClose\" [popover]=\"closingPopup\" placement=\"bottom\"\n      containerClass=\"closing-popup\" outsideClick=\"true\" #pop></i>\n    <i class=\"close-button\" role=\"button\" [attr.aria-label]=\"'cxone-components.modal.close' | translate\" *ngIf=\"allowClose\" [innerHTML]=\"iconClose\" tabindex=\"1\" (keyup.enter)=\"dismiss()\" (click)=\"dismiss()\"></i>\n  </div>\n  <div class=\"modal-body-wrapper\">\n    <ng-content select=\"cxone-modal-body\"></ng-content>\n    <ng-content></ng-content>\n  </div>\n  <div class=\"modal-footer-wrapper\">\n    <ng-content select=\"cxone-modal-footer\" *ngIf=\"customFooter\"></ng-content>\n    <button class=\"cxone-btn btn-medium btn-secondary btn-bg-is-white cancel-btn\" *ngIf=\"!allowClose && !customFooter\"\n      [popover]=\"closingPopup\" outsideClick=\"true\" placement=\"top\"  tabindex=\"1\" containerClass=\"closing-popup\" #pop>\n      <span *ngIf=\"cancelLabel\">{{ cancelLabel }}</span>\n      <span *ngIf=\"!cancelLabel\">{{ 'cxone-components.modal.cancel' | translate }}</span>\n    </button>\n    <button class=\"cxone-btn btn-medium btn-secondary btn-bg-is-white cancel-btn\" tabindex=\"1\" *ngIf=\"allowClose && !customFooter\"\n      (click)=\"dismiss()\">\n      <span *ngIf=\"cancelLabel\">{{ cancelLabel }}</span>\n      <span *ngIf=\"!cancelLabel\">{{ 'cxone-components.modal.cancel' | translate }}</span>\n    </button>\n    <button class=\"cxone-btn btn-medium btn-primary save-btn\" (click)=\"close()\" tabindex=\"1\" [disabled]=\"saveDisabled\"\n      [hidden]=\"saveHidden\" *ngIf=\"!customFooter\">\n      <span *ngIf=\"saveLabel\">{{ saveLabel }}</span>\n      <span *ngIf=\"!saveLabel\">{{ 'cxone-components.modal.save' | translate }}</span>\n    </button>\n  </div>\n</div>\n<ng-template #closingPopup>\n  <div class=\"closing-popup\">\n    <p>{{ 'cxone-components.modal.message1' | translate }}</p>\n    <p>{{ 'cxone-components.modal.message2' | translate }}</p>\n    <div class=\"button-wrapper\">\n      <button id=\"close-popover\" class=\"cxone-btn btn-secondary btn-medium btn-bg-is-white\"  tabindex=\"1\"\n              (click)=\"closePopover()\"><span>{{ 'cxone-components.modal.no' | translate }}</span>\n      </button>\n      <button id=\"exit-yes-btn\" (click)=\"dismiss()\" tabindex=\"1\"\n              class=\"cxone-btn btn-medium btn-primary\"><span>{{ 'cxone-components.modal.yes' | translate }}</span>\n      </button>\n    </div>\n  </div>\n</ng-template>\n",
      styles: [".cxone-modal-wrapper{position:absolute;font-family:OpenSans;display:flex;box-shadow:0 5px 20px #0a141a;flex-direction:column;height:100%;width:100%;margin:auto 0}.cxone-modal-wrapper .closing-popup{display:table!important;background:#373b3f;border-radius:0;max-width:250px}.cxone-modal-wrapper .closing-popup.popover-bottom .arrow:after{border-bottom-color:#373b3f}.cxone-modal-wrapper .closing-popup.popover-top .arrow:after{border-top-color:#373b3f}.cxone-modal-wrapper .closing-popup .popover-content{color:#fff}.cxone-modal-wrapper .closing-popup .popover-content .closing-popup p{margin-bottom:10px}.cxone-modal-wrapper .closing-popup .popover-content .closing-popup .button-wrapper{margin-top:14px;display:flex;align-items:center;justify-content:flex-end}.cxone-modal-wrapper .closing-popup .popover-content .closing-popup .button-wrapper button{margin-left:8px}.cxone-modal-wrapper .modal-header-wrapper{display:flex;height:60px;align-items:center;border-top-left-radius:5px;border-top-right-radius:5px;background-color:#fff;padding:0 30px;flex-grow:0;flex-shrink:0}.cxone-modal-wrapper .modal-header-wrapper .content-wrapper{flex:1;padding-top:5px}.cxone-modal-wrapper .modal-header-wrapper .content-wrapper .headerTitle,.cxone-modal-wrapper .modal-header-wrapper .content-wrapper .headerSubtitle{font-size:16px;color:#2e2e2e}.cxone-modal-wrapper .modal-header-wrapper .close-button{cursor:pointer;width:18px;height:18px;fill:#526b7a;opacity:.8}.cxone-modal-wrapper .modal-header-wrapper .close-button:hover{fill:#2d78c2}.cxone-modal-wrapper .modal-header-wrapper .close-button:active{fill:#237bc2}.cxone-modal-wrapper .modal-header-wrapper .close-button svg{pointer-events:none;position:relative;left:-2px}.cxone-modal-wrapper .modal-body-wrapper{flex:1;background-color:#eaf1f7;overflow:auto;position:relative}.cxone-modal-wrapper .modal-footer-wrapper{display:flex;align-items:center;justify-content:flex-end;border-bottom-right-radius:5px;border-bottom-left-radius:5px;background-color:#fff;height:48px;width:100%}.cxone-modal-wrapper .modal-footer-wrapper cxone-modal-footer{flex:1}.cxone-modal-wrapper .modal-footer-wrapper .cancel-btn,.cxone-modal-wrapper .modal-footer-wrapper .save-btn{margin-right:10px}.cxone-modal-wrapper .modal-footer-wrapper button[hidden]{display:none}.cxone-modal-wrapper.modal-size-sm .modal-header-wrapper{padding:0 20px}.cxone-modal-wrapper.modal-size-sm .modal-body-wrapper{padding:20px;position:relative}.cxone-modal-wrapper.modal-size-md .modal-header-wrapper{padding:0 30px}.cxone-modal-wrapper.modal-size-md .modal-body-wrapper{padding:25px 30px;position:relative}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], {
    allowClose: [{
      type: Input
    }],
    cancelLabel: [{
      type: Input
    }],
    customHeader: [{
      type: Input
    }],
    customFooter: [{
      type: Input
    }],
    headerSubtitle: [{
      type: Input
    }],
    headerTitle: [{
      type: Input
    }],
    saveDisabled: [{
      type: Input
    }],
    saveHidden: [{
      type: Input
    }],
    saveLabel: [{
      type: Input
    }],
    modalSize: [{
      type: Input
    }],
    focusOnShow: [{
      type: Input
    }],
    cxoneModalWrapper: [{
      type: ViewChild,
      args: ['cxoneModalWrapper']
    }],
    closed: [{
      type: Output
    }],
    dismissed: [{
      type: Output
    }],
    popovers: [{
      type: ViewChildren,
      args: ['pop', {
        read: PopoverDirective
      }]
    }]
  });
})();
class ModalHeaderComponent {
  /** @nocollapse */static {
    this.ɵfac = function ModalHeaderComponent_Factory(t) {
      return new (t || ModalHeaderComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalHeaderComponent,
      selectors: [["cxone-modal-header"]],
      ngContentSelectors: _c5,
      decls: 1,
      vars: 0,
      template: function ModalHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-modal-header',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class ModalBodyComponent {
  /** @nocollapse */static {
    this.ɵfac = function ModalBodyComponent_Factory(t) {
      return new (t || ModalBodyComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalBodyComponent,
      selectors: [["cxone-modal-body"]],
      ngContentSelectors: _c5,
      decls: 1,
      vars: 0,
      template: function ModalBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalBodyComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-modal-body',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class ModalFooterComponent {
  /** @nocollapse */static {
    this.ɵfac = function ModalFooterComponent_Factory(t) {
      return new (t || ModalFooterComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalFooterComponent,
      selectors: [["cxone-modal-footer"]],
      ngContentSelectors: _c5,
      decls: 1,
      vars: 0,
      template: function ModalFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalFooterComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-modal-footer',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class MessageModalComponent {
  constructor(domSanitizer, dialogRef, config) {
    this.dialogRef = dialogRef;
    this.config = config;
    this.titleOnly = false;
    this.focusOnShow = false;
    this.multilineTitle = false;
    this.svgIcons = new SvgIcons(domSanitizer);
  }
  ngOnInit() {
    if (this.config.data.messageTemplate && typeof this.config.data.messageTemplate === 'object') {
      this.messageTpl = this.config.data.messageTemplate;
    }
    this.message = this.config.data.message;
    if ((!this.message || this.message.length === 0) && !this.messageTpl) {
      this.titleOnly = true;
    }
    if (this.config.data.multilineTitle) {
      this.multilineTitle = true;
    }
    this.type = this.config.data.type;
    this.icon = this.svgIcons.getSvgIcons(this.type);
    this.title = this.config.data.title;
    this.focusOnShow = this.config.data.focusOnShow;
    this.primaryButtonText = this.config.data.primaryButtonText;
    this.closeButtonText = this.config.data.closeButtonText;
  }
  onClose() {
    this.dialogRef.close(true);
  }
  onDismiss() {
    this.dialogRef.close(false);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function MessageModalComponent_Factory(t) {
      return new (t || MessageModalComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i2.DynamicDialogRef), i0.ɵɵdirectiveInject(i2.DynamicDialogConfig));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MessageModalComponent,
      selectors: [["cxone-message-modal"]],
      decls: 13,
      vars: 16,
      consts: [[1, "cxone-message-modal", 3, "ngClass"], [3, "focusOnShow", "customFooter", "customHeader", "ngClass", "closed", "dismissed"], [1, "message-modal-header-wrapper"], [1, "type-icon", 3, "innerHTML"], [1, "text", 3, "ngClass"], [1, "message", 3, "innerHTML"], [3, "ngTemplateOutlet"], ["class", "cxone-btn btn-medium btn-secondary", 3, "click", 4, "ngIf"], ["class", "cxone-btn btn-medium btn-primary", 3, "click", 4, "ngIf"], [1, "cxone-btn", "btn-medium", "btn-secondary", 3, "click"], [1, "cxone-btn", "btn-medium", "btn-primary", 3, "click"]],
      template: function MessageModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "cxone-modal", 1);
          i0.ɵɵlistener("closed", function MessageModalComponent_Template_cxone_modal_closed_1_listener() {
            return ctx.onClose();
          })("dismissed", function MessageModalComponent_Template_cxone_modal_dismissed_1_listener() {
            return ctx.onDismiss();
          });
          i0.ɵɵelementStart(2, "cxone-modal-header")(3, "div", 2);
          i0.ɵɵelement(4, "i", 3);
          i0.ɵɵelementStart(5, "span", 4);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(7, "cxone-modal-body");
          i0.ɵɵelement(8, "span", 5);
          i0.ɵɵelementContainer(9, 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "cxone-modal-footer");
          i0.ɵɵtemplate(11, MessageModalComponent_button_11_Template, 2, 1, "button", 7)(12, MessageModalComponent_button_12_Template, 2, 1, "button", 8);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c6, ctx.titleOnly));
          i0.ɵɵadvance();
          i0.ɵɵproperty("focusOnShow", ctx.focusOnShow)("customFooter", true)("customHeader", true)("ngClass", ctx.type);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHTML", ctx.icon, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c7, ctx.multilineTitle));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.title);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHTML", ctx.message, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.messageTpl);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.closeButtonText);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.primaryButtonText);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent],
      styles: [".cxone-message-modal{height:100%}.cxone-message-modal cxone-modal.user-info .modal-footer-wrapper,.cxone-message-modal cxone-modal.system-info .modal-footer-wrapper{border-top:1px solid rgb(0,124,190)}.cxone-message-modal cxone-modal.user-warning .modal-footer-wrapper,.cxone-message-modal cxone-modal.system-warning .modal-footer-wrapper{border-top:1px solid rgb(239,167,22)}.cxone-message-modal cxone-modal.user-error .modal-footer-wrapper,.cxone-message-modal cxone-modal.system-error .modal-footer-wrapper{border-top:1px solid rgb(208,48,59)}.cxone-message-modal cxone-modal .cxone-modal-wrapper{background-color:#fff;border-radius:5px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper{padding:0 20px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .close-button{margin-bottom:20px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper{padding-top:0;width:calc(100% - 18px)}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper{display:flex}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper .type-icon{display:inline-block;width:20px;height:20px;margin-right:9px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper .text{max-width:calc(100% - 30px);font-size:16px;line-height:20px;height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#2e2e2e}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper .text.multiline{overflow:visible;text-overflow:unset;white-space:unset;z-index:1}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-body-wrapper{background-color:#fff;padding:0 50px;font-size:13px;min-height:75px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-footer-wrapper{background-color:#f5f5f5}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-footer-wrapper cxone-modal-footer{display:flex;align-items:center;justify-content:flex-end}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-footer-wrapper button{margin-right:10px}.cxone-message-modal.title-only cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper{padding-top:30px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageModalComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-message-modal',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"cxone-message-modal\"\n     [ngClass]=\"{ 'title-only': titleOnly }\">\n  <cxone-modal [focusOnShow]=\"focusOnShow\" [customFooter]=\"true\" [customHeader]=\"true\" [ngClass]=\"type\" (closed)=\"onClose()\"\n    (dismissed)=\"onDismiss()\">\n    <cxone-modal-header>\n      <div class=\"message-modal-header-wrapper\">\n        <i class=\"type-icon\" [innerHTML]=\"icon\"></i>\n        <span class=\"text\" [ngClass]=\"{'multiline': multilineTitle}\">{{ title }}</span>\n      </div>\n    </cxone-modal-header>\n    <cxone-modal-body>\n      <span class=\"message\" [innerHTML]=\"message\"></span>\n      <ng-container [ngTemplateOutlet]=\"messageTpl\"></ng-container>\n    </cxone-modal-body>\n    <cxone-modal-footer>\n      <button class=\"cxone-btn btn-medium btn-secondary\" (click)=\"onDismiss()\"\n        *ngIf=\"closeButtonText\">{{ closeButtonText }}</button>\n      <button class=\"cxone-btn btn-medium btn-primary\" (click)=\"onClose()\"\n        *ngIf=\"primaryButtonText\">{{ primaryButtonText }}</button>\n    </cxone-modal-footer>\n  </cxone-modal>\n</div>\n",
      styles: [".cxone-message-modal{height:100%}.cxone-message-modal cxone-modal.user-info .modal-footer-wrapper,.cxone-message-modal cxone-modal.system-info .modal-footer-wrapper{border-top:1px solid rgb(0,124,190)}.cxone-message-modal cxone-modal.user-warning .modal-footer-wrapper,.cxone-message-modal cxone-modal.system-warning .modal-footer-wrapper{border-top:1px solid rgb(239,167,22)}.cxone-message-modal cxone-modal.user-error .modal-footer-wrapper,.cxone-message-modal cxone-modal.system-error .modal-footer-wrapper{border-top:1px solid rgb(208,48,59)}.cxone-message-modal cxone-modal .cxone-modal-wrapper{background-color:#fff;border-radius:5px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper{padding:0 20px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .close-button{margin-bottom:20px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper{padding-top:0;width:calc(100% - 18px)}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper{display:flex}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper .type-icon{display:inline-block;width:20px;height:20px;margin-right:9px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper .text{max-width:calc(100% - 30px);font-size:16px;line-height:20px;height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#2e2e2e}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper .message-modal-header-wrapper .text.multiline{overflow:visible;text-overflow:unset;white-space:unset;z-index:1}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-body-wrapper{background-color:#fff;padding:0 50px;font-size:13px;min-height:75px}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-footer-wrapper{background-color:#f5f5f5}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-footer-wrapper cxone-modal-footer{display:flex;align-items:center;justify-content:flex-end}.cxone-message-modal cxone-modal .cxone-modal-wrapper .modal-footer-wrapper button{margin-right:10px}.cxone-message-modal.title-only cxone-modal .cxone-modal-wrapper .modal-header-wrapper .content-wrapper{padding-top:30px}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i2.DynamicDialogRef
  }, {
    type: i2.DynamicDialogConfig
  }], null);
})();
class ModalModule {
  /** @nocollapse */static {
    this.ɵfac = function ModalModule_Factory(t) {
      return new (t || ModalModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ModalModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      imports: [CommonModule, TranslationModule, DynamicDialogModule, OverflowTooltipModule, PopoverModule.forRoot(), TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalModule, [{
    type: NgModule,
    args: [{
      declarations: [MessageModalComponent, ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent],
      imports: [CommonModule, TranslationModule, DynamicDialogModule, OverflowTooltipModule, PopoverModule.forRoot(), TranslationModule],
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      exports: [MessageModalComponent, ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MessageModalComponent, ModalBodyComponent, ModalComponent, ModalFooterComponent, ModalHeaderComponent, ModalModule };
